import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GlobalMessageService, GlobalMessageType, RoutingService, TranslationService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { ForgotPasswordService } from 'src/app/services/feature/forgot-pwd/forgot-password.service';
@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss'],
  standalone: false
})
export class UpdatePasswordComponent {
  submitted = false;
  tokenValue: string;
  private translatedValue: string;
  private timerId: any;
  subscription = new Subscription();

  constructor(private activatedRoute: ActivatedRoute,
    private service: ForgotPasswordService,
    protected globalMessage: GlobalMessageService,
    protected routingService: RoutingService,
    private trservice: TranslationService,
    protected cd: ChangeDetectorRef) { }

  pwdchangeForm = new FormGroup(
    {
      password: new FormControl(
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(12),
          this.regexTester(new RegExp("(?=.*[0-9])"), {
            requiresDigit: true
          }),
          this.regexTester(new RegExp("(?=.*[A-Z])"), {
            requiresUppercase: true
          }),
          this.regexTester(new RegExp("(?=.*[a-z])"), {
            requiresLowercase: true
          }),
          this.regexTester(new RegExp("(?=.*[()~!@#$%^&*\\-_+=`|{}\\[\\]:;\"'<>,?/])"), {
            requiresSpecialChars: true
          })
        ])
      ),
      confirmPassword: new FormControl(null, [
        Validators.required,
        Validators.minLength(12)
      ])
    },
    {
      validators: this.compareBoth
    }
  );
  get pwdform() {
    return this.pwdchangeForm.controls;
  }

  get passwordValid() {
    return this.pwdchangeForm.controls["password"].errors === null;
  }

  get requiredValid() {
    return !this.pwdchangeForm.controls["password"].hasError("required");
  }

  get minLengthValid() {
    return !this.pwdchangeForm.controls["password"].hasError("minlength");
  }

  get requiresDigitValid() {
    return !this.pwdchangeForm.controls["password"].hasError("requiresDigit");
  }

  get requiresUppercaseValid() {
    return !this.pwdchangeForm.controls["password"].hasError("requiresUppercase");
  }

  get requiresLowercaseValid() {
    return !this.pwdchangeForm.controls["password"].hasError("requiresLowercase");
  }

  get requiresSpecialCharsValid() {
    return !this.pwdchangeForm.controls["password"].hasError("requiresSpecialChars");
  }
  ngOnInit() {
    this.subscription.add(this.activatedRoute.queryParams.subscribe(param => {
      this.tokenValue = param?.['token'];

    }));
  }
  onSubmit() {

    const updateData = {
      token: encodeURIComponent(this.tokenValue),
      newpassword: encodeURIComponent(this.pwdchangeForm.controls['password'].value)
    }
    this.subscription.add(this.service.updatePassword(updateData).subscribe((result: any) => {
      if (result && (result?.status == 'error')) {
        this.globalMessage.add(
          { key: result?.message },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
      else {
        this.globalMessage.add(
          { key: 'common.text_account_confirmation_password_updated' },
          GlobalMessageType.MSG_TYPE_INFO
        );
        this.timerId = setTimeout(() => {
          this.routingService.go({ cxRoute: 'login' });
        }, 5000)
      }
    }, (error) => {
      this.globalMessage.add(
        { key: 'common.updatePwd_token_invalidated' },
        GlobalMessageType.MSG_TYPE_ERROR
      );
      this.routingService.go({ cxRoute: 'login' });
    }));
  }
  translateserv(key, options) {
    this.subscription.add(this.trservice
      .translate(key, options, true)
      .subscribe((val) => this.markForCheck(val)));
  }
  private markForCheck(value: string) {
    this.translatedValue = value;
    this.cd.markForCheck();
  }

  compareBoth(control: AbstractControl) {
    const password = control.get('password')?.value;
    const confirmPasswordControl = control.get('confirmPassword');

    if (!confirmPasswordControl) {
      return null;
    }

    const confirmPassword = confirmPasswordControl.value;

    // Check if confirm password is empty
    if (!confirmPassword || confirmPassword.trim() === '') {
      confirmPasswordControl.setErrors({ required: true });
      return { required: true };
    }

    // Check min length
    if (confirmPassword.length < 12) {
      confirmPasswordControl.setErrors({ minLength: true });
      return { minLength: true };
    }

    // Check password mismatch
    if (password !== confirmPassword) {
      confirmPasswordControl.setErrors({ mismatch: true });
      return { mismatch: true };
    }

    // Clear errors if all good
    confirmPasswordControl.setErrors(null);
    return null;
  }

  regexTester(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control.value) {
        return null;
      }

      const valid = regex.test(control.value);

      return valid ? null : error;
    };
  }
  ngOnDestroy() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  }
}
